import vegan from '../images/vegan.png';
import vegetarian from '../images/vegetarian.png';
import halal from '../images/halal.png';
import fresh from '../images/fresh.png';
import video from '../images/video.png';
import chilled from '../images/chilled.png';
import frozen from '../images/frozen.png';
import msc from '../images/msc.png';
import popular from '../images/popular.png';
import {
  BRAINTREE_PATH,
  PAYMENT_CALLBACK_PATH,
  SUCCESS_PATH,
} from './routePaths';

export const JJ_DOMAIN = {
  PROD: 'www.jjfoodservice.com',
  W: 'w.jjfoodservice.com',
  DEV: 'olympus-uat.jjfoodservice.com',
};

// Credit application outcome codes returned by credit-check-svc (mirrors the
// backend CreditOutcome enum).
export const OUTCOME_MESSAGE_CODES = {
  REFERRED: 'REFERRED',
  DECLINED: 'DECLINED',
  NOT_FOUND: 'NOT_FOUND',
};
export const FILTERS = {
  origin: 'Origin',
  sizeOrCut: 'Size',
  brand: 'Brand',
  categoryList: 'Category',
  productFeatures: 'Features',
};

export const FILTERS_NAME = {
  categoryList: 'categoryList',
  productFeatures: 'productFeatures',
};

export const CATEGORY_FILTER_KEY = 'category';

export const FILTER_KEYS = [
  'brand',
  'origin',
  'sizeOrCut',
  'productFeatures',
  CATEGORY_FILTER_KEY,
];

export const NON_CATEGORY_FILTER_KEYS = FILTER_KEYS.filter(
  key => key !== CATEGORY_FILTER_KEY
);

export const DOTS = '...';

export const DEFAULT_BRANCH = 'EN-MW';

export const SORT_TYPES = {
  SEARCH: 'search',
  CATEGORY: 'category',
  OFFER: 'offer',
  POPULAR: 'popular',
};

export const SEARCH_PARAMS = {
  b: DEFAULT_BRANCH,
  size: 12,
  sortType: SORT_TYPES.SEARCH,
};

// product-search-svc applies a minScore to every non-advanced search and
// filters contribute no score, so a filter-only browse has to send '*' to
// match anything.
export const MATCH_ALL_QUERY = '*';

export const SEARCH_ADVANCED_PARAMS = {
  size: 12,
  q: MATCH_ALL_QUERY,
  advanced: true,
};

export const OFFER_PARAMS = {
  size: 20,
  sortType: SORT_TYPES.OFFER,
};

export const SEARCH_SORT_TYPE = {
  RELEVANCE: 'relevance',
  PRICE_HIGH: 'pricehigh',
  PRICE_LOW: 'pricelow',
  CATEGORY: 'category',
  BRAND: 'brand',
  NAME: 'name',
  NEW: 'newproducts',
  OFFER: 'offer',
  // Curated-list order. Must match SORT_TYPE_LIST in graph-product-search,
  // which sorts on listMembership.position — if that token is renamed the
  // order silently reverts to the default sort.
  LIST: 'list',
};

export const SEARCH_SORT_OPTIONS = [
  {value: SEARCH_SORT_TYPE.RELEVANCE, label: 'Relevance'},
  {value: SEARCH_SORT_TYPE.CATEGORY, label: 'Categories'},
  {value: SEARCH_SORT_TYPE.NAME, label: 'Name'},
  {value: SEARCH_SORT_TYPE.PRICE_LOW, label: 'Price: Low to High'},
  {value: SEARCH_SORT_TYPE.PRICE_HIGH, label: 'Price: High to Low'},
];

// Shown only on curated-list pages, prepended to the standard options so the
// user can return to curated order after sorting by something else.
export const CURATED_LIST_SORT_OPTION = {
  value: SEARCH_SORT_TYPE.LIST,
  label: 'Featured',
};

export const PAGE_SIZE = {
  S: '12',
  M: '48',
  L: '96',
};

export const SERVICE_TYPE = {
  DELIVERY: 'DELIVERY',
  COLLECTION: 'COLLECTION',
  DELIVERED: 'Delivered',
  COLLECTED: 'Collected',
  UNSELECTED: 'UNSELECTED',
};

export const JJ_TEL = '01992 701 701';
export const JJ_MOBILE = '07870 176 015';
export const JJ_TEL_FULL = '+441992701701';
export const JJ_MOBILE_FULL = '+447870176015';

export const DEFAULT_DATE_FORMAT = 'D MMMM, YYYY';
export const OFFER_ENDS_DATE_FORMAT = 'DD/MM/YY';
export const OFFER_END_DATE_FULL_FORMAT = 'DD/MM/YYYY';
export const OFFER_ENDS_DATE_FORMAT_SHORT = 'DD/MM';
export const AVAILABLE_AT_DATE_FROM_FORMAT = 'YYYYMMDD';
export const AVAILABLE_AT_DATE_FORMAT = 'DD/MM';
export const ORDER_SERVICE_DATE_FORMAT = 'DD-MM-YYYY';
export const SLOT_DATE_FORMAT = 'DD-MM-YYYY';
export const DATE_FORMAT = 'DD/MM/YYYY';
export const ORDER_HISTORY_DATE_FORMAT = 'DD/MM/YY, HH:mm';
export const ORDER_HISTORY_UNTIL_DATE_FORMAT = 'HH:mm on DD/MM';
export const ORDER_HISTORY_OUT_DATE_FORMAT = 'dddd DD MMMM';
export const ORDER_HISTORY_PDF_DATE_FORMAT = 'dddd DD MMMM, HH:mm';
export const H_MM_A_FORMAT = 'h:mma';
export const UTC_TIME_FORMAT = 'DD/MM/YYYY, HH:mm';
export const CUTOFF_TIME_FORMAT = 'HH:mm on Do MMMM';
export const CHECKOUT_BEFORE_TIME_FORMAT = 'HH:mm';
export const FULFILLMENT_SUCCESS_FORMAT = 'Do MMMM';
export const STANDARD_FORMAT = 'YYYY-MM-DD';
export const FULL_TIME_FORMAT = 'YYYY-MM-DDThh:mm:ss';
export const STANDARD_REPORT_FORMAT = 'DD MM YYYY';

export const GOOGLE_MAP = 'https://maps.googleapis.com/maps/api';
export const GOOGLE_STATIC_URL = 'https://www.google.com/maps/dir';

export const ROUTES = {
  PRODUCT: 'product',
  BASKET: 'basket',
  SEARCH: 'search',
  SEARCH_RESULTS: 'searchResults',
  HOME: 'home',
  CHECKOUT: 'checkout',
  OFFERS: 'offers',
  BOOK_SLOT: 'bookSlot',
  ORDERS: 'orders',
  ORDER: 'order',
  FAVOURITES: 'favourites',
  RECENT_PURCHASES: 'recentPurchases',
  RECOMMENDED: 'recommended',
  SETTINGS: 'settings',
  BRANCH_LOCATOR: 'branchLocator',
  CONFIRMATION: 'confirmation',
  TRACKING: 'Tracking',
  SHOPPING_LISTS: 'ShoppingLists',
  SHOPPING_LISTS_CONTENT: 'ShoppingListsContent',
  OWN_LABELS: 'ownLabels',
  BLOGS: 'blogs',
  JJCONTENT: 'jjcontent',
  MANAGE_PAYMENT: 'cardonfile',
  REPORTS: 'reports',
  PANDG: 'pandg',
  HALAL: 'halal',
};

export const CONTENT_SITE = {
  MIX_N_SAVE: '/content/MixandSave',
};

export const PANDG_CATEGORIES = [
  {
    key: 'dishwashing',
    label: 'Dishwashing',
    description: 'Fairy makes grease-cutting easy – manual and machine.',
    query: 'PGPRODW',
    adTitle: 'DISHWASHING',
    image: 'https://cdn.jjfoodservice.com/cms/dishwashing_0fdb7fcbd9.jpeg',
  },
  {
    key: 'degreasing',
    label: 'Degreasing',
    description: 'Deepio cuts tough grease, oil and grime fast.',
    query: 'PGPRODG',
    adTitle: 'DEGREASING',
    image: 'https://cdn.jjfoodservice.com/cms/degreasing_afc2544948.jpeg',
  },
  {
    key: 'floorCare',
    label: 'Floor Care',
    description: 'Flash cares for tile, vinyl, wood and stone.',
    query: 'PGPROFC',
    adTitle: 'FLOOR CARE',
    image: 'https://cdn.jjfoodservice.com/cms/floorcare_ef0644a3f6.jpeg',
  },
  {
    key: 'hardSurfaceCleaning',
    label: 'Hard Surface Cleaning',
    description: 'Milton and Flash make food-safe disinfecting easy.',
    query: 'PGPROHSC',
    adTitle: 'HARD SURFACE CLEANING',
    image: 'https://cdn.jjfoodservice.com/cms/hardsurface_ee3aa032cf.jpeg',
  },
  {
    key: 'concentratedSystemSolutions',
    label: 'Concentrated System Solutions',
    description: 'Concentrated dosing – less waste, lower cost',
    query: 'PGPROCSS',
    adTitle: 'CONCENTRATED SYSTEM SOLUTIONS',
    image: 'https://cdn.jjfoodservice.com/cms/system_a3dcfb63ad.jpeg',
  },
  {
    key: 'laundryDetergents',
    label: 'Laundry Detergents',
    description: 'Ariel, Bold and More – for linen and uniform care.',
    query: 'PGPROLD',
    adTitle: 'LAUNDRY DETERGENTS',
    image: 'https://cdn.jjfoodservice.com/cms/laundry_c4aa7ac7ff.jpeg',
  },
  {
    key: 'laundrySystemSolutions',
    label: 'Laundry System Solutions',
    description: 'Auto-dosing Ariel and Lenor for high-volume laundry',
    query: 'PGPROLSS',
    adTitle: 'LAUNDRY SYSTEM SOLUTIONS / AUTO -DOSE LAUNDRY',
    image: 'https://cdn.jjfoodservice.com/cms/solutions_4426b3b528.jpeg',
  },
];

export const PANDG_ALL_CATEGORY = {
  key: 'all',
  label: 'All P&G Pro',
  description: 'Browse the complete P&G PRO range',
  query: 'PGPRO',
  adTitle: 'P&G Pro Range',
};

export const PANDG_BANNER_IMAGE_URL =
  'https://cdn.jjfoodservice.com/cms/jjdelivery_L_b3b6e251f1.jpg';

export const PANDG_BROCHURE_URL =
  'https://cdn.jjfoodservice.com/cms/2026_08_Pn_G_Pro_ba2bde44ae.pdf';

export const PANDG_SWATCHES = [
  {$from: '#fdf3c7', $to: '#fff'},
  {$from: '#dceeff', $to: '#fff'},
  {$from: '#e5ddf5', $to: '#fff'},
  {$from: '#cfeee0', $to: '#fff'},
  {$from: '#d7ecff', $to: '#fff'},
  {$from: '#d7f2d0', $to: '#fff'},
  {$from: '#eee', $to: '#fff'},
];

export const JJ_LOCAL_STORAGE = {
  TOKEN: '@JJFoodService.token',
  LOGIN_TOKEN: '@JJFoodService.loginToken',
  REFRESH_TOKEN: '@JJFoodService.refreshToken',
  LAST_AUTH_TIME: '@JJFoodService.lastAuthTime',
  ACCOUNTS: '@JJ.accounts',
  C_ACCOUNT: '@JJ.c_account',
  FAVOURITES: 'JJ.favourites',
  FULFILLMENT: 'JJ.fulfillment',
  TOKEN_VALID_UNTIL: 'JJ.token.valid_until',
  ORDER_ID: 'JJ.orderId',
  ORDER_AX_BASKETID: 'JJ.orderAxBasketId',
  DEVICE_ID: 'JJ.deviceId',
  EDIT_ORDER_TIME: 'JJ.edit_order.time',
  EDIT_ORDER_PAYMENT_METHOD: 'JJ.edit_order.payment_method',
  CATCH_WEIGHT_ITEMS: 'JJ.catch_weight_items',
  GA_CLIENT_ID: '_ga',
  TRACKING_KEY: '@JJFoodService.tracking',
  LAST_UPSELLING_TIME: 'JJ.last_upselling',
  ANONYMOUS_INVOICE_PROCESS_ID: 'JJ.anonymous_invoice_process_id',
};

export const JJ_SESSION_STORAGE = {
  VERIFIER: '@JJFoodService.verifier',
  CHALLENGE: '@JJFoodService.challenge',
  AZURE_STATE: '@JJFoodService.azState',
  REFERER: '@JJFoodService.referer',
  DEVICE_ID: '@JJFoodService.deviceId',
  SESSION_ID: '@JJFoodService.sessionId',
  DISCOUNT_CODE: '@JJFoodService.discountCode',
};

export const TRACKING_FIELDS = {
  SRSLTID: 'srsltid',
  LANDING_REFERRER: 'landingReferrer',
};

export const PRODUCT_TABS = [
  {
    name: 'Ingredients',
  },
  {
    name: 'Nutrition values',
  },
  {
    name: 'Allergy advice',
  },
  {
    name: 'Usage info',
  },
  {
    name: 'Storage & size',
  },
];

export const ANALYTICS_DIMENSIONS = {
  BRANCH_CODE_DIMENSION: 'dimension1',
  FULLFILLMENT_DIMENSION: 'dimension2',
};

export const ANALYTICS_EVENT_CATEGORIES = {
  MENU: 'MENU',
  SETTINGS: 'SETTINGS',
  SHOPPING_CART: 'ShoppingCart',
  JAVASCRIPT_ERROR: 'JavaScript Error',
  NODE_ERROR: 'Node Error',
  SUBSTITUTE: 'Substitute',
  HOMEPAGE_BANNERS: 'Home Banners',
};

export const ANALYTICS_SOURCES = {
  OFFERS: 'Offers',
  RECOMMENDED: 'Recommended',
  FAVOURITES: 'Favourites',
  HOMEPAGE_OFFERS: 'Homepage offers',
  PRODUCT_DETAIL: 'Product detail',
  SEARCH: 'Search',
  // A category (or other non-keyword) product listing on /search.
  BROWSE: 'Browse',
  // Removals on the basket page.
  BASKET: 'Basket',
  SHOPPING_LIST: 'Shopping list',
  // Peer-gap trial cards spliced into the search grid. A distinct source is what makes the
  // trial's conversions separable from ordinary search adds in reporting.
  FEATURED_SEARCH: 'Featured in search',
  // The "related products" strip under a short or empty search (graph-product-search
  // relatedProducts). Its own source so its adds are never counted as ordinary search adds.
  RELATED_SEARCH: 'Related in search',
  PREVIOUSLY_PURCHASED: 'Previously purchased',
  SUBSTITUTES: 'Substitutes',
  PRICE_COMPARE_ADD_ALL: 'price-compare-add-all',
  PRICE_COMPARE_ADD_CHEAPER: 'price-compare-add-cheaper',
  // Add Item clicks on the /halal landing page's "Halal Essentials" showcase — a distinct
  // source from HALAL_PAGE_VIEW itself, since that's the page-view event, not this add.
  HALAL_BEST_SELLER: 'halal_best_seller',
};

// Copy for the peer-gap trial cards spliced into the search grid. All of it lives here rather
// than in FeaturedProduct so the wording can be changed without touching the component, and so
// the whole trial reads as one block when it comes to pulling it back out.
export const FEATURED_ITEM_HEADING = 'Shops like yours also buy this';
export const FEATURED_ITEM_TOOLTIP_INTRO =
  'Shops like yours buy this regularly, so we have added it to your results.';
export const FEATURED_ITEM_TOOLTIP_LABEL = 'Why am I seeing this product?';
// Fallback reason when the trial data supplies no per-item one.
export const FEATURED_ITEM_DEFAULT_REASON = 'Shops like yours stock this';

// "Did you mean": a search that found nothing comes back with results for a spelling correction
// (graph-product-search `correctedQuery`). `correct=false` in the URL is the customer asking for
// their own words instead, and travels with every later page and filter change of that search.
export const SEARCH_CORRECTED_PREFIX = 'Showing results for';
export const SEARCH_INSTEAD_PREFIX = 'Search instead for';
export const SEARCH_CORRECT_PARAM = 'correct';
export const SEARCH_CORRECT_OFF = 'false';

// `related=false` in the URL hides the related-products strip for that search, so a link to one
// brand's results (a campaign, a supplier deal) does not offer that brand's competitors underneath.
// Like `correct`, it travels with every later page and filter change of that search.
export const SEARCH_RELATED_PARAM = 'related';
export const SEARCH_RELATED_OFF = 'false';

// relatedProducts strategy that means "nothing to show".
export const RELATED_STRATEGY_NONE = 'NONE';
export const RELATED_STRATEGY = {
  SIMILAR: 'SIMILAR',
  PARTIAL: 'PARTIAL',
  BUY_AGAIN: 'BUY_AGAIN',
  NEW_PRODUCTS: 'NEW_PRODUCTS',
};
// Headings for the related strip on the web. The empty-results sentence above the strip already says
// the search found nothing, so these stay short; graph-product-search's own `title` (which says
// "No results for ..." itself, for clients with no empty state) is the fallback for any strategy
// not listed here, and is what SIMILAR uses ("Similar to Straight Cut Chips").
export const RELATED_HEADINGS = {
  BUY_AGAIN: 'Buy Again',
  NEW_PRODUCTS: 'New Products',
};
export const RELATED_PARTIAL_HEADING_PREFIX = 'Results for';

// Empty search results. With a query the sentence repeats it, so a typo is plain at a glance.
export const NO_RESULTS_MESSAGE = 'Sorry, no matching product found';
export const NO_RESULTS_FOR_QUERY_PREFIX =
  "Sorry, we couldn't find any products matching";

export const ANALYTICS_EVENT_SOURCE = 'WEB';

export const ANALYTICS_EVENTS = {
  ACCEPT_SUBSTITUTE: 'Accept substitute',
  ADD_FAVOURITE: 'Add favourite',
  ADD_PRODUCT: 'Add product',
  ADYEN_EVENTS: 'Adyen activities',
  ADYEN_PAYMENT: 'Adyen Payment',
  AZURE_ERROR: 'Azure B2C error',
  // Catch weight box picker. Registered in analytics-svc as generic events.
  BOX_CHECKOUT_UNAVAILABLE: 'box_checkout_unavailable',
  BOX_PICK_ATTEMPT: 'box_pick_attempt',
  BOX_PICK_FAILURE: 'box_pick_failure',
  BOX_PICK_SUCCESS: 'box_pick_success',
  BOX_PICKER_OPEN: 'box_picker_open',
  BOX_PROMISE_SHOWN: 'box_promise_shown',
  BOX_REMOVE: 'box_remove',
  BANNER_CLICK: 'home_banner',
  BRAINTREE_ERROR: 'Braintree error',
  BRANCH_LOCATOR_SEARCH: 'Branch Locator Search',
  BROWSE_MENU: 'Browse menu',
  CHECKOUT_SLOT_EXPIRED: 'Checkout slot expired',
  CHECKOUT_STATUS: 'Checkout status change',
  CLOSE_ACCOUNT: 'Close Account',
  CONFIRM_ORDER: 'Confirm Order',
  DRIVERS_FEEDBACK: 'Drivers feedback',
  FEATURED_IMPRESSION: 'featured_impression',
  // The related-products strip was shown under a search.
  RELATED_IMPRESSION: 'related_impression',
  // A product in that strip was clicked through to its product page.
  RELATED_PRODUCT_CLICK: 'related_product_click',
  GENERIC_BANNER_CLICK: 'Generic homepage banner click',
  HOME_LOWER_BIG: 'home_block_main',
  HOME_LOWER_SMALL: 'home_block_small',
  IGNORE_NEW_OFFER_POPUP: 'Ignore new offers popup',
  LOGIN: 'Login',
  LOGIN_ERROR: 'Login error',
  LOGIN_SUCCESS: 'Login Success',
  LOGOUT: 'Logout',
  MODAL_TOGGLE: 'modal_toggle',
  OWN_LABELS: 'Own label products',
  PAGE_VIEW: 'page_view',
  PAYMENT_CALLBACK: 'Payment callback',
  PAYMENT_FAILED: 'Payment failed',
  // "Confirm payment" clicked on a PAYMENT_AUTH_REQUIRED order.
  PAYMENT_REQUIRED_CONFIRM: 'Payment required confirm',
  PBB_PAY_ANOTHER_WAY: 'PBB pay another way',
  // Checkout found an earlier Pay By Bank payment still pending and showed
  // that order instead of starting another payment.
  PBB_PAYMENT_IN_PROGRESS: 'PBB payment in progress',
  PBB_PAYMENT_PENDING: 'PBB payment pending',
  PBB_PAYMENT_PENDING_EXPIRED: 'PBB payment pending expired',
  // The status left PAYMENT_PENDING while the customer was on the page.
  PBB_PAYMENT_PENDING_RESOLVED: 'PBB payment pending resolved',
  // The pending copy switched to "waiting for your bank".
  PBB_PAYMENT_PENDING_SLOW: 'PBB payment pending slow',
  // Back from the bank on a Pay By Bank order that has no status yet: the
  // provider's notification has not reached us.
  PBB_AWAITING_BANK: 'PBB awaiting bank',
  PRICE_NOT_FOUND: 'Price not found',
  PURCHASE_FAILED: 'Purchase Failed',
  RATINGS_FEEDBACK: 'Ratings feedback',
  REMOVE_BASKET: 'Remove basket',
  REMOVE_FAVOURITE: 'Remove favourite',
  REMOVE_PRODUCT: 'Remove Product',
  REPORT_TYPE_CHANGE: 'Report type change',
  REQUEST_REFUND: 'Request refund',
  SEARCH: 'Search',
  SEARCH_ALTERNATIVES: 'Search alternatives',
  SEARCH_RESULTS: 'Search results',
  // A search that found nothing was answered with a spelling correction ("Showing results for milk").
  SEARCH_CORRECTED: 'search_corrected',
  // The customer chose "Search instead for <what they typed>" over the correction.
  SEARCH_INSTEAD_CLICK: 'search_instead_click',
  SEARCH_SUGGESTIONS: 'search_suggestions',
  SET_FULFILLMENT: 'Set fulfilment',
  SET_PAYMENT_TYPE: 'Set payment type',
  SET_SETTINGS: 'Set settings',
  SHOP_BY_SECTORS: 'Shop by sectors',
  START_PAYMENT: 'Start Payment',
  TRANSACTION_TYPE_CHANGE: 'Transaction type change',
  USER_INTEREST_DELIVERY_AREA_CHANGE:
    'inform when JJ starts delivering to my area',
  VIEW_CART: 'view_cart',
  VIEW_ITEM: 'view_item',
  VIEW_NEW_OFFER_POPUP: 'View new offers popup',
  COMPARE_PRICES_PAGE_VIEW: 'Compare prices page view',
  COMPARE_PRICES_UPLOAD: 'Compare prices upload',
  COMPARE_PRICES_UPLOAD_SUCCESS: 'Compare prices upload success',
  COMPARE_PRICES_UPLOAD_FAILED: 'Compare prices upload failed',
  COMPARE_PRICES_VIEW_DETAIL: 'Compare prices view detail',
  COMPARE_PRICES_PRODUCT_CLICK: 'Compare prices product click',
  HALAL_PAGE_VIEW: 'Halal page view',
  COMPARE_PRICES_ADD_ALL_TO_BASKET: 'Compare prices add all to basket',
  COMPARE_PRICES_ADD_ALL_TO_FAVOURITES: 'Compare prices add all to favourites',
  COMPARE_PRICES_ADD_ALL_TO_SHOPPING_LIST:
    'Compare prices add all to shopping list',
  CREATE_SIGNUP_UPLOAD: 'Create signup upload',
  CREATE_SIGNUP_UPLOAD_SUCCESS: 'Create signup upload success',
  CREATE_SIGNUP_UPLOAD_FAILED: 'Create signup upload failed',
  CREATE_SIGNUP_SUBMIT: 'Create signup submit',
  CREATE_SIGNUP_SUBMIT_SUCCESS: 'Create signup submit success',
  CREATE_SIGNUP_SUBMIT_FAILED: 'Create signup submit failed',
  CREATE_SIGNUP_VIEW_PRICE_COMPARISON: 'Create signup view price comparison',
  CREATE_SIGNUP_ACCOUNT_CREATION_ACCEPTED:
    'Create signup account creation accepted',
  CREATE_SIGNUP_ACCOUNT_CREATION_DECLINED:
    'Create signup account creation declined',
  CREATE_SIGNUP_FOLLOW_UP_ACCEPTED: 'Create signup follow up accepted',
  CREATE_SIGNUP_FOLLOW_UP_DECLINED: 'Create signup follow up declined',
  // The product page's "Leave a review".
  PRODUCT_REVIEW_SUBMIT: 'Product review submit',
  PRODUCT_REVIEW_SUBMIT_SUCCESS: 'Product review submit success',
  PRODUCT_REVIEW_SUBMIT_FAILED: 'Product review submit failed',
  // Post-delivery "How were your products?" popup.
  ORDER_FEEDBACK_VIEW: 'Order feedback view',
  ORDER_FEEDBACK_SUBMIT: 'Order feedback submit',
  ORDER_FEEDBACK_SUBMIT_SUCCESS: 'Order feedback submit success',
  ORDER_FEEDBACK_SUBMIT_FAILED: 'Order feedback submit failed',
  ORDER_FEEDBACK_MAYBE_LATER: 'Order feedback maybe later',
  ORDER_FEEDBACK_DISMISS: 'Order feedback dismiss',
};

export const INVOICE_UPLOAD_ACCEPTED_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/webp',
];

export const INVOICE_UPLOAD_MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB per file

export const INVOICE_UPLOAD_STATUS_MATCHED = 'MATCHED';

export const INVOICE_UPLOAD_STATUS_LABELS = {
  PROCESSING: 'Reading invoice',
  READY_FOR_REVIEW: 'Finding prices',
  SUBMITTED: 'Finding prices',
  MATCHED: 'Results ready',
  EMAIL_SENT: 'Results ready',
  FAILED: 'Could not process',
  DUPLICATE: 'Already uploaded',
  TOO_OLD: 'Too old to compare',
  NOT_AN_INVOICE: 'No invoice found',
};

// Fallback for overview.comparisonWindowDays, which the service only sets on a
// TOO_OLD comparison. Keep in step with invoice-comparison.max-invoice-age-days.
export const INVOICE_UPLOAD_DEFAULT_COMPARISON_WINDOW_DAYS = 90;

// Status groupings for the progressive price-comparison flow.
// Extraction in progress (nothing to show yet); extraction done, matching in
// progress (show extracted lines); matching complete (show results).
export const INVOICE_UPLOAD_EXTRACTING_STATUSES = ['PROCESSING'];
export const INVOICE_UPLOAD_MATCHING_STATUSES = [
  'READY_FOR_REVIEW',
  'SUBMITTED',
];
export const INVOICE_UPLOAD_COMPLETE_STATUSES = ['MATCHED', 'EMAIL_SENT'];

// Every status the comparison can end on — results in hand, or stopped short of
// any. Derive "still working" from this one list rather than negating a chain of
// per-status flags: a status added here but missed off such a chain leaves the
// progress tracker spinning on a comparison that will never change.
export const INVOICE_UPLOAD_TERMINAL_STATUSES = [
  'MATCHED',
  'EMAIL_SENT',
  'FAILED',
  'DUPLICATE',
  'TOO_OLD',
  'NOT_AN_INVOICE',
];

// Poll for progress until matching completes; the fallback covers a stalled
// pipeline so the results page doesn't spin forever — the customer still gets
// the email.
export const INVOICE_UPLOAD_POLL_INTERVAL_MS = 2500;
export const INVOICE_UPLOAD_MATCH_FALLBACK_MS = 120000;

// Processing never finishes in under ~20s, so the first status check waits
// until then rather than polling a job that can't possibly be done yet.
export const INVOICE_UPLOAD_INITIAL_POLL_DELAY_MS = 20000;

// The results page (InvoiceUploadDetail) arrives straight from the upload
// redirect with a progress tracker already on screen, so it can afford a
// shorter wait than the panel above before its first poll.
export const INVOICE_UPLOAD_DETAIL_POLL_START_DELAY_MS = 10000;

// The public (anonymous) invoice-scanning endpoint has been seen returning
// 429 when calls land too close together (e.g. the quota check on mount
// followed straight by an upload) — space out consecutive calls to it by at
// least this long.
export const INVOICE_UPLOAD_ANONYMOUS_CALL_GAP_MS = 2000;

// Labels for the three-step progress tracker on the results page.
export const INVOICE_UPLOAD_PROGRESS_STEP_LABELS = [
  'Reading invoice',
  'Finding prices',
  'Your savings',
];

// Reading is the longest, opaque stage (the backend reports a single PROCESSING
// status for it). Cycle through these so the screen visibly moves and it never
// looks stalled. Pairs with the animated progress bar.
export const INVOICE_UPLOAD_READING_MESSAGES = [
  'Scanning your invoice…',
  'Reading the line items…',
  'Checking quantities and prices…',
  'Tidying up the details…',
  'Almost there — nearly ready to compare…',
];
export const INVOICE_UPLOAD_READING_MESSAGE_INTERVAL_MS = 4500;

export const INVOICE_UPLOAD_MATCHING_CAPTION =
  "Great — we've read your invoice! We're now finding you the best JJ price on each item. This only takes a few more seconds.";
export const INVOICE_UPLOAD_TIMED_OUT_CAPTION =
  "Almost there — this one's taking a little longer than usual. Feel free to carry on browsing and we'll email your savings report the moment it's ready.";
// Anonymous visitors have no email on file, so the results can't be emailed
// to them — point them back at this page (bookmark/URL) instead.
export const INVOICE_UPLOAD_ANONYMOUS_TIMED_OUT_CAPTION =
  "Almost there — this one's taking a little longer than usual. Feel free to carry on browsing; keep this page bookmarked and your savings report will be here when it's ready.";

// Anonymous (not-logged-in) price-comparison allowance — see
// AnonymousUploadQuota returned by GET /api/invoice-scanning/api/public/invoices/quota.
export const INVOICE_UPLOAD_ANONYMOUS_QUOTA_EXCEEDED_MESSAGE =
  "You've compared your free invoices for now. Register for a free account to keep comparing.";

// Copy for the card shown in place of the upload form once the quota above
// is used up.
export const INVOICE_UPLOAD_ANONYMOUS_QUOTA_EXCEEDED_TITLE =
  "Keep comparing — it's still free";
export const INVOICE_UPLOAD_ANONYMOUS_QUOTA_EXCEEDED_BODY =
  'Open a free JJ Foodservice account to carry on checking your invoices and see how much you can save with us.';

export const INVOICE_UPLOAD_ADD_TO_SHOPPING_LIST_ERROR =
  "We couldn't add these items to a shopping list. Please try again or contact customer support if the problem persists.";

export const PAYMENT_CALLBACK_CODE = {
  SUCCESS: '1',
  FAIL: '0',
};

export const PRODUCTS_PER_LINE = 4;

export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{8,}$/;

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const PROTOCOL_REGEX = '^(?:[a-z]+:)?//';
export const DATE_PICKER_REGEX = /(\d{2})-(\d{2})-(\d{4})/;
export const REGISTER_TEL_REGEX = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
export const AX_MOBILE_REGEX = /^(\+44\s?07\d{3}|\(?7\d{3}\)?)\s?\d{3}\s?\d{3}$/;
export const FILE_NAME_REGEX = /(?=\w+\.\w{3,4}$).+/;
export const ONLY_SPACES_REGEX = /^\s+$/;
export const SKU_REGEX = /[A-Z]{3}[0-9]{3}/;
export const ONLY_NUMBER_REGEX = /^-?\d+$/;
export const FASTLY_FORMAT_REGEX = /w_[0-9]{1,4},h_\d[0-9]{1,4},c_scale\//;
export const IMAGE_PRODUCT_ID_REGEX = /v[0-9]+\/products/;
export const BASE64_PRE_REGEX = /^data:image\/[a-z]+;base64,/;
export const FILE_EXT_REGEX = /\.[0-9a-z]+$/i;
export const INTEGER_REGEX = /^-?[0-9]+$/;

export const HTTPS_REGEX = /^(http|https):\/\//i;

export const INVALID_SEARCH_SUGGESTION_KEYWORD = /\b(?:\w{3}\d{3}\b(?:,|\s*)){2,}/;
export const SEARCH_SUGGESTION_MAX_LENGTH = 30;
export const SENTRY_ALLOWED_URLS = /https?:\/\/((olympus-uat|www|w)\.)?jjfoodservice\.com/;
export const SENTRY_APPLICATION_KEY = '@JJFoodService.olympus-app';
export const SENTRY_DEDUPE_CACHE_KEY = 'sentry-error-cache-v1';
export const SENTRY_DEDUPE_WINDOW_MS = 24 * 60 * 60 * 1000;

export const GET_LOGIN_TOKEN_FAILED = 'GET_LOGIN_TOKEN_FAILED';

export const FULFILLMENT_TYPES = {
  DELIVERY: 7,
  COLLECTION: 8,
};

export const UPDATING_TYPES = {
  BASKET: 'BASKET',
  ITEM: 'ITEM',
  REMOVE: 'REMOVE',
  FULFILLMENT: 'FULFILLMENT',
};

export const HTTP_STATUS = {
  NETWORK_NOT_AVAILABLE: 0,
  OK: 200,
  ACCEPTED: 202,
  MOVED_PERMANENTLY: 301,
  FOUND: 302,
  NOT_FOUND: 404,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBBIDEN: 403,
  CONFLICT: 409,
  EXCEED_SIZE_LIMIT: 413,
  UNPROCESSABLE: 422,
  NEED_RETRY: 423,
  SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
};

export const ERRORS = {
  UNAUTHORIZED: 'unauthorized',
  EXPIRED: 'invalid_token',
  NEED_AUTH: 'authentication_required',
  HTTP_SERVER_ERROR: 'http_server_error',
  SERVER_ERROR: 'server_error',
  INTERNAL_SERVER_ERROR: 'internal_server_error',
  BASKET: 'basket',
  NULL: 'null_pointer',
  SLOT_EXPIRED: 'slot_expired',
  TOTAL_DISCREPANCY: 'total_discrepancy',
  BASKET_NO_ITEMS: 'basket_no_items',
  BASKET_ONLY_OOS_ITEMS: 'basket_only_oos_items',
  INVALID_BASKET_ITEM: 'invalid_basket_item',
  UPDATE_BASKET: 'update_basket',
  PRICE_NOT_FOUND: 'price_not_found',
  UPDATE_SUBSTITUTE_ITEM: 'update_substitute_item',
  BASKET_MIN_DELIVERY_ORDER: 'basket_min_order',
  ORDER_ERROR: 'order',
  ILLEGAL_ARGUMENT: 'illegal_argument',
  FATAL_SERVER_ERROR: 'Internal Server Error',
  REMOVE_ITEM: 'error_removing_item',
  NOT_FOUND: 'Not Found',
  ORDER_FAILED: 'get order failed',
  ORDER_UNAUTHORIZED: 'get order unauthorized',
  SET_VOUCHER_AX_BASKET: 'set_voucher_ax_basket',
  EXISTING_SUBMITTED: 'existing_submitted_order',
  NOT_FOUND_404: 'Request failed with status code 404',
  INVALID_TOKEN: 'Invalid Token',
  ACCESS_DENIED: 'access_denied',
  WEB_SOCKET: 'websocket error',
  PICKED: 'picked_order_not_editable',
  NOT_EDITABLE: 'order_not_editable',
  AX_BASKET_NOT_FOUND: 'ax_basket_not_found',
  TIMEOUT: 'timeout',
  NOT_AUTHORIZED: 'not authorized',
  NON_ERROR_PROMISE: /Non-Error promise rejection captured|Object captured as promise rejection with keys/,
  COMMERCIAL_CARD_ERROR: 'Business card not permitted.',
  CONSUMER_CARD_ERROR: 'Consumer card not permitted.',
  REQUEST_ABORTED: 'Request aborted',
  REQUEST_ABORTED_RX: /Request aborted/i,
  NEXTWORK_ERROR: 'Network Error',
  BOX_UNAVAILABLE: 'box_unavailable',
  BOX_LINE_QUANTITY_DERIVED: 'box_line_quantity_derived',
  NEXTWORK_ERROR_RX: /Network Error/i,
  MODULE_IMPORT_FAILED: 'Importing a module script failed.',
  SAFARI_LOAD_FAILED: 'Load failed',
  RUNTIME_SEND_MESSAGE: /Invalid call to runtime\.sendMessage\(\)/,
  SAFARI_CUSTOM_EVENT_REJECTION: /CustomEvent.*type=unhandledrejection/,
  // Some backends (e.g. profileApi's favourites endpoint) signal an expired
  // token as a 403 access_denied with this message, rather than a plain 401 —
  // see axiosHelper's response interceptor in api.helper.js.
  JWT_TOKEN_EXPIRED_RX: /JWT Token Expired/i,
};

// Catch weight box picker (docs/catchweight-box-picker-plan.md).
export const BOX_PICKER_SOURCE = {
  ADD: 'add',
  CHANGE: 'change',
  UNAVAILABLE: 'unavailable',
};

// Always show the picker on these hosts regardless of CONFIG_JS's boxPicker
// flag, so testing there isn't blocked by that flag's rollout state.
export const BOX_PICKER_FORCED_HOSTS = [
  'olympus-dev.jjfoodservice.com',
  'olympus-uat.jjfoodservice.com',
];

// Message codes jj-basket-svc can put on a basket line.
export const BOX_MESSAGE_CODES = {
  LEDGER_UNAVAILABLE: 'BOX_LEDGER_UNAVAILABLE',
};

// Buckets for the `reason` param of box_pick_failure, matched against the
// server's message text (BoxMessages.kt) so raw copy never reaches GA4.
export const BOX_PICK_FAILURE_REASONS = [
  {match: /taken/i, reason: 'taken'},
  {match: /ready for your chosen day/i, reason: 'not_ready'},
  {match: /available at your branch/i, reason: 'branch'},
  {match: /switched off/i, reason: 'disabled'},
  {match: /temporarily unavailable/i, reason: 'ledger_unavailable'},
];
export const BOX_PICK_FAILURE_REASON_REQUEST = 'request_error';
export const BOX_PICK_FAILURE_REASON_OTHER = 'other';

export const BOX_WEIGHT_DECIMALS = 2;

export const BOX_PICKER_COPY = {
  ADD_BOXES: count => `Add ${count} ${count === 1 ? 'box' : 'boxes'}`,
  ADD_ANOTHER_BOX: 'Add another box',
  BOX_COUNT: count => `${count} ${count === 1 ? 'box' : 'boxes'}`,
  CHANGE_BOXES: 'Change boxes',
  CHOOSE_A_BOX: 'Choose a box',
  CLOSE: 'Close',
  ESTIMATED_PRICE: 'Estimated price',
  LEDGER_UNAVAILABLE:
    "We can't check your boxes right now because of an issue on our end. They're still in your basket - please try again shortly.",
  INTRO:
    'Choose the boxes you want. Each box is weighed, so you pay for its exact weight.',
  OK: 'OK',
  PER_KG: 'per kg',
  PROMISE:
    "No boxes to choose from right now. We'll set one aside for you from the next delivery - its exact weight and price will be on your invoice.",
  PEEK_ERROR:
    "We couldn't load the boxes for this item because of an issue on our end. Please try again shortly - your basket hasn't changed.",
  REMOVE: 'Remove',
  REQUEST_ERROR:
    "We couldn't add these boxes because of an issue on our end. Please try again - your basket hasn't changed.",
  SELECTED: 'Selected',
  TITLE: 'Choose your boxes',
};

export const DAILY_LIMIT_REACHED_MESSAGE =
  "This item has reached its daily limit for your chosen day, so we can't supply it. Please remove it or choose another day - the rest of your basket is unaffected.";

export const BOX_CHECKOUT_UNAVAILABLE_MESSAGE = {
  TITLE: 'A box in your basket is no longer available',
  CONTENT:
    "One of the boxes you chose is no longer available, so we haven't placed your order and you haven't been charged. Please choose another box in your basket and try again.",
};

export const BASKET_ERRORS_TYPE = {
  PAYMENT_TYPE: 'payment type',
  REMOVE: 'remove',
  UPDATE: 'update',
  SLOT_EXPIRED: 'slot expired',
  SLOT_EXPIRED_DURING_CHECKOUT: 'slot expired during checkout',
  FAILED_TO_EDIT_ORDER: 'Failed to edit order, please try again later',
};

export const AX_BASKET_ERRORS = {
  STARTED_PICKING:
    'Sorry, your order can no longer be edited as the warehouse has started picking it. Please create a new order instead',
  AX_BASKET_NOT_FOUND:
    'Sorry, your order can no longer be edited as it has been cancelled.',
  NOT_EDITABLE: 'Sorry, your order can no longer be edited.',
};

export const PAYMENT_ERROR_MESSAGE = {
  GENERAL: 'Something went wrong, please try again.',
  ANOTHER_METHOD: 'Please try another payment method.',
};

export const ERROR_HTTP_STATUS = {
  NOT_FOUND: 'NOT_FOUND',
};

export const PRODUCT_FEATURES = {
  Chilled: chilled,
  Fresh: fresh,
  Frozen: frozen,
  Vegan: vegan,
  Halal: halal,
  Video: video,
  Vegetarian: vegetarian,
  MSC: msc,
  Popular: popular,
};

export const MAIN_PRODUCT_TAGS = {
  Vegetarian: vegetarian,
  Frozen: frozen,
  MSC: msc,
  Popular: popular,
};

export const HTTP_ACCEPTED = 'Accepted';

export const AUTH_ORIGIN = {
  USER_PASS: 'USER_PASS',
  ENHANCED: 'ENHANCED',
  REFRESH: 'REFRESH',
};

export const UPSELLING_STEPS = {
  0: 'targetedItems',
  1: 'forgottenItems',
  2: 'seeThoseDeals',
  3: 'flashSales',
};

export const DAYS_FROM_TODAY = {
  TODAY: 0,
  TOMORROW: 1,
};

export const REPORT_TYPES = [
  'Summary Statement',
  'Consolidated Invoice',
  'Product Analysis',
  'Product Analysis By Account',
  'Sales Transaction',
];
export const REPORT_EMBED_URL = {
  'Summary Statement':
    'https://app.powerbi.com/rdlEmbed?reportId=3cddc292-ba37-401c-bad9-6309f8f4b172&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLU5PUlRILUVVUk9QRS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
  'Consolidated Invoice':
    'https://app.powerbi.com/rdlEmbed?reportId=7d8e8b87-c6c3-4cfe-8327-761373b7a0e7&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLU5PUlRILUVVUk9QRS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
  'Product Analysis':
    'https://app.powerbi.com/rdlEmbed?reportId=5e23a9dd-0612-4996-8fb9-b746fd9adf1b&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLU5PUlRILUVVUk9QRS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
  'Product Analysis By Account':
    'https://app.powerbi.com/rdlEmbed?reportId=e955c5fd-cde7-411c-b2dc-3d75cd7ca381&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLU5PUlRILUVVUk9QRS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
  'Sales Transaction':
    'https://app.powerbi.com/rdlEmbed?reportId=60721028-900a-44d3-bffa-36c0476c000c&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLU5PUlRILUVVUk9QRS1yZWRpcmVjdC5hbmFseXNpcy53aW5kb3dzLm5ldCIsImVtYmVkRmVhdHVyZXMiOnsidXNhZ2VNZXRyaWNzVk5leHQiOnRydWV9fQ%3d%3d',
};

export const REPORT_REPORT_ID = {
  'Summary Statement': '3cddc292-ba37-401c-bad9-6309f8f4b172',
  'Consolidated Invoice': '7d8e8b87-c6c3-4cfe-8327-761373b7a0e7',
  'Product Analysis': '5e23a9dd-0612-4996-8fb9-b746fd9adf1b',
  'Product Analysis By Account': 'e955c5fd-cde7-411c-b2dc-3d75cd7ca381',
  'Sales Transaction': '60721028-900a-44d3-bffa-36c0476c000c',
};

export const CUSTOMER_TYPES = {
  ALL: 'All',
};

export const REGISTER_CUSTOMER_TYPES = {
  CNM: 'CNM',
  OVE: 'OVE',
};

export const REGISTER_WHERE_DID_YOU_HEAR_ABOUT_US = [
  'Google search',
  'Word of mouth',
  'Facebook',
  'Instagram',
  'Twitter',
  'LinkedIn',
  'Press & media',
  'Sales representative',
  'Printed marketing',
  'Event or exhibition',
  'JJ Blog',
];
export const REGISTER_WHERE_DID_YOU_HEAR_ABOUT_US_NA = 'N/A';

export const TRANSACTION_TYPES = {
  ALL: 'All',
  OUTSTANDING: 'Outstanding',
};

export const CAREERS_IMAGES_URL =
  'https://jjimages.global.ssl.fastly.net/jjfoodservice/careers/';

export const AX_BASKET_STATUS = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  FAILURE: 'FAILURE',
  SYNCED: 'SYNCED',
  EXPIRED: 'EXPIRED',
  PICKED: 'PICKED',
  PAYMENT_AUTH_REQUIRED: 'PAYMENT_AUTH_REQUIRED',
  PENDING: 'PENDING',
  IN_PROGRESS_REPLAY: 'IN_PROGRESS_REPLAY',
};

export const AX_ERRORS = {
  QUANTITY_UNAVAILABLE: 'product_quantity_not_available',
  UNAVAILABLE: 'not_available',
  DAILY_LIMIT: 'daily_limit',
  OUT_OF_STOCK: 'out_of_stock',
  BASKET: 'ax_basket',
};

export const FORM_ERRORS = {
  REQUIRED: 'required',
  INVALID: 'invalid',
};

export const AD_ERRORS = {
  LOGIN_CANCELLED: 'AADB2C90091',
};

export const STOCK_CHECK = {
  IN_STOCK: 'IN_STOCK',
  PARTIAL_STOCK: 'PARTIAL_STOCK',
  OUT_OF_STOCK: 'OUT_OF_STOCK',
  DAILY_LIMIT: 'DAILY_LIMIT',
  DISCONTINUED: 'DISCONTINUED',
  NOT_ALLOWED: 'NOT_ALLOWED',
  BOX_UNAVAILABLE: 'BOX_UNAVAILABLE',
};

export const SETTINGS = {
  INSTRUCTIONS: 'instructions',
  BRANCH: 'branchId',
  FULFILLMENT: 'fulfillment',
  PAYMENT_TYPE: 'paymentType',
  BASKET_UUID: 'basketUuid',
  EDIT_ORDER_TIME: 'editOrderTime',
  USER_SEARCH_KEYWORDS: 'srchKeywords',
  NOCONTACTINFO: 'noContactInfo',
  DELIVERY_CONTACT_NUMBER: 'deliveryContactNumber',
  DEFAULT_SLOT_REFERENCE: 'defaultSlotReference',
  BRAINTREE: 'braintree',
  RATINGS: 'showRatings',
  APPLE_PAY: 'allowApplePay',
  GOOGLE_PAY: 'allowGooglePay',
  PAYPAL: 'allowPaypal',
  ADYEN: 'adyen',
  ANALYTICS_CLIENT_ID: 'analyticsClientId',
  CARD_ON_FILE: 'cardOnFile',
};

// Values the staff payment-setting dropdowns write to the profile.
export const SETTING_TOGGLE = {
  ENABLED: 'true',
  DISABLED: 'false',
};

// What an *unset* payment setting means to its consumers. CheckoutPage only
// treats `braintree` as on when it is literally 'true', and jj-order-svc reads
// every one of these with getOrDefault(key, "false"). The staff dropdowns must
// display these same defaults: showing "Enabled" for an unset key meant that
// selecting another value and putting it back persisted 'true', which is how
// monthly-account (COB) customers ended up flagged for card-on-file payment.
export const SETTING_DEFAULTS = {
  [SETTINGS.BRAINTREE]: SETTING_TOGGLE.DISABLED,
  [SETTINGS.ADYEN]: SETTING_TOGGLE.DISABLED,
  [SETTINGS.APPLE_PAY]: SETTING_TOGGLE.DISABLED,
  [SETTINGS.GOOGLE_PAY]: SETTING_TOGGLE.DISABLED,
  [SETTINGS.PAYPAL]: SETTING_TOGGLE.DISABLED,
  [SETTINGS.CARD_ON_FILE]: SETTING_TOGGLE.DISABLED,
};

export const AUTHORITIES = {
  ROLE_USER: 'ROLE_USER',
  ROLE_STAFF: 'ROLE_STAFF',
  ROLE_VENDOR: 'ROLE_VENDOR',
};

export const PAYMENT_TYPES = {
  BAC: {
    mode: 'BAC',
    title: 'CREDIT FACILITY',
  },
  BCDC: {
    mode: 'BCDC',
    title: 'BUSINESS CARD',
  },
  CAS: {
    mode: 'CAS',
    title: 'CASH',
  },
  CDC: {
    mode: 'CDC',
    title: 'CREDIT / DEBIT CARD',
  },
  CHQ: {
    mode: 'CHQ',
    title: 'CHEQUE',
  },
  COB: {
    mode: 'COB',
    title: 'CREDIT FACILITY',
  },
  COC: {
    mode: 'COC',
    title: 'CASH OR CHEQUE',
  },
  PCP: {
    mode: 'PCP',
    title: 'PURCHASE CARD PAYMENT',
  },
  PBB: {
    mode: 'PBB',
    title: 'PAY BY BANK',
  },
};

export const DEFAULT_PAYMENT_TYPE = [
  {
    mode: 'CDC',
    name: 'Credit / Debit card',
  },
];

export const PAYMENT_TYPES_MAPPING = {
  CREDIT_CARD: 'CREDIT / DEBIT CARD',
  CASH: 'CASH',
  INVOICE: 'CREDIT FACILITY',
  BAC: 'CREDIT FACILITY',
  BCDC: 'BUSINESS CARD',
  CAS: 'CASH',
  CDC: 'CREDIT / DEBIT CARD',
  CHQ: 'CHEQUE',
  COB: 'CREDIT FACILITY',
  COC: 'CASH OR CHEQUE',
  PCP: 'PURCHASE CARD PAYMENT',
  PBB: 'PAY BY BANK',
};

export const MAX_RETRY = 3;
export const MAX_ORDER_RETRY = 5;
export const MAX_SOCKET_RETRY = 5;
// Refresh the access token this long before it expires.
export const TOKEN_REFRESH_MARGIN_MS = 5 * 60 * 1000;
// notifier-svc rejects a socket whose token does not verify with this connect_error message.
export const NOTIFIER_UNAUTHORISED_MESSAGE = 'not authorized';
// After notifier-svc sends force-reload (a newer Olympus is live), the page reloads the next time the user
// navigates to one of these browsing pages, so a form, checkout or payment in progress is never interrupted.
export const FORCE_RELOAD_PATH_PREFIXES = [
  '/search',
  '/product',
  '/productDetail',
  '/category',
  '/brand',
  '/offers',
  '/favourites',
  '/recentpurchases',
  '/recommended',
  '/orders',
  '/own-brands',
  '/halal',
  '/JJ-PGP',
  '/content',
  '/blog',
  '/basket',
];
export const RETRY_TIMEOUT = 3000;
export const GET_ORDER_RETRY_TIMEOUT = 10000;
// How long a Pay By Bank payment may stay pending before the confirmation page
// stops saying it is confirming and explains a bank-side approval wait. Trustly
// usually send pending and credit together.
export const PBB_PENDING_SLOW_TIMEOUT = 60 * 1000;
export const BASKET_RETRY_TIMEOUT = 3000;
export const BASKET_RECHECK_TIMEOUT = 500;
export const REACH_MAX_TIMEOUT = 1500;
export const MESSAGE_TIMEOUT = 4000;
export const TIMEOUT_TIME = 10000;
export const MESSAGE_GAP_TIMEOUT = 4000;
export const BASKET_SYNC_TIMEOUT = 10000;
export const LAST_CHECKOUT_CHECK_TIMEOUT = 10000;
export const CHECKOUT_TAKING_LONGER_TIMEOUT = 8000;
export const CHECKOUT_TAKING_LONGEST_TIMEOUT = 20000;
export const A_MINUTE = 60 * 1000;
export const A_HOUR = 60 * 60 * 1000;
// How often the confirmation page re-reads a held Pay By Bank order, by how
// long it has been pending. Most payments credit within a minute or two; a
// longer wait is a bank-side approval, which does not need a 10 s poll for
// the whole of the hold.
export const PBB_PENDING_POLL_SCHEDULE = [
  {after: 0, every: GET_ORDER_RETRY_TIMEOUT},
  {after: 2 * A_MINUTE, every: 30 * 1000},
  {after: 10 * A_MINUTE, every: A_MINUTE},
];
export const A_DAY = 24 * 60 * 60 * 1000;
export const A_YEAR = 365 * A_DAY;
export const NEVER = 9999999999999;
export const CHECKOUT_UPSELL_TIMEOUT = 10 * 60 * 1000;
export const MAX_BASKET_SYNC_RETRIES = 5;
export const REDIRECT_DELAY_TIME = 500;
export const DEFAULT_DEBOUNCE_TIME = 500;
export const SEARCH_SUGGESTIONS_DEBOUNCE_TIME = 250;
export const STORE_DELAY_TIME = 300;
export const RE_GET_BASKET_TIME = 30 * 1000;
export const CLOSE_MODAL_DELAY_TIME = 1000;
export const ANALYTICS_API_DELAY_TIME = 1000;
export const APP_REDIRECT_TIMEOUT = 50;
export const ORDER_EDIT_TIMEOUT = 30000;
export const BUBBLE_POPUP_TIMEOUT = 5000;

export const PUBLIC_STATIC_CACHE_EXTENSIONS = new Set([
  '.css',
  '.gif',
  '.ico',
  '.jpg',
  '.jpeg',
  '.js',
  '.png',
  '.svg',
  '.webp',
]);
export const HASHED_STATIC_CACHE_CONTROL =
  'public, max-age=31536000, immutable';
export const PUBLIC_STATIC_CACHE_CONTROL =
  'public, max-age=86400, must-revalidate';

export const PAGE_DES = {
  TITLE:
    'JJ Foodservice | UK Wholesale Food & Catering Supplies, Cash & Carry and Online Orders for Delivery, Collection, Export',
  TITLE_CONTENT: 'Online | Wholesale | Cash & Carry | Delivery | Export',
  DESCRIPTION:
    'We sell wholesale food and catering supplies to consumers and businesses across the UK and for export. Register on our website to order with us today.',
};

export const SEARCH_TITLE = {
  NEW: 'New Products',
  ALL_PRODUCTS: 'All Products',
};

export const ORDER_STATUSES = {
  SUBMITTED: 'Submitted',
  CREATED: 'Received',
  APPROVED: 'Received',
  ONHOLD: 'Received',
  PICKED: 'Picked',
  DISPATCHED: 'Dispatched',
  INVOICED: 'Invoiced',
  CANCELLED: 'Cancelled',
  PAYMENT_AUTHORIZED: 'Received',
  PAYMENT_AUTHORIZE_FAILED: 'Payment failed - please contact Support',
  PAYMENT_SETTLED: 'Invoiced',
  PAYMENT_SETTLE_FAILED: 'Payment failed - please contact Support',
  PAYMENT_VOIDED: 'Payment refunded',
};

export const AX_ORDER_STATUS = {
  PAYMENT_VOIDED: 'PAYMENT_VOIDED',
  // Pay By Bank: the bank has accepted the payment but not credited it yet, so
  // the order is held and not placed until it does.
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  // The bank never credited it and the hold has lapsed: nothing was placed, the
  // basket is still there.
  PAYMENT_PENDING_EXPIRED: 'PAYMENT_PENDING_EXPIRED',
  // A placed order whose payment was reversed or failed and must be paid
  // again; the customer confirms the payment from the orders page.
  PAYMENT_AUTH_REQUIRED: 'PAYMENT_AUTH_REQUIRED',
  CANCELLED: 'CANCELLED',
  SUCCESS: 'SUCCESS',
  SUBMITTED: 'SUBMITTED',
  APPROVED: 'APPROVED',
  DISPATCHED: 'DISPATCHED',
  SLOT_EXPIRED: 'SLOT_EXPIRED',
  EDIT_EXPIRED: 'EDIT_EXPIRED',
  TOTAL_DISCREPANCY: 'TOTAL_DISCREPANCY',
};

export const SLOT_FULFILMENT_STATUSES = {
  OK: 'OK',
  DEFAULT_SLOT: 'DEFAULT_SLOT',
  SLOT_NOT_AVAILABLE: 'SLOT_NOT_AVAILABLE',
  SLOT_ADJUSTED: 'SLOT_ADJUSTED',
  TYPE_ADJUSTED: 'TYPE_ADJUSTED',
};

export const MIN_ORDER_AMOUNT = {
  OTHERS: 79,
  'MN-MW': 79,
};

export const IMAGE_SIZE = {
  LARGE: 'w_700,h_700',
  MEDIUM: 'w_304,h_304',
  MAIN_GRID: 'w_500,h_500',
  GRID: 'w_450,h_450',
  BROCHURE: 'w_600,h_852',
  BANNER: 'w_1000,h_380',
  THUMBNAIL: 'w_80,h_80',
  // Google Merchant Center requires product images >= 1024px on the longest side
  SCHEMA: 'w_1200,h_1200',
  FULLSCREEN: 'w_1200,h_1200',
  FULLSCREEN_MOBILE: 'w_1000,h_1000',
};

// Google Merchant Center unit pricing: sizeOrCut units ("1x4.05l", "60x80ml", "1x59's")
// normalised to one base unit per type, matching the site's "per kg / per litre / each".
export const UNIT_PRICING_BASE = {
  WEIGHT: 'kg',
  VOLUME: 'l',
  COUNT: 'ct',
};

export const UNIT_PRICING_UNITS = {
  kg: {base: UNIT_PRICING_BASE.WEIGHT, factor: 1},
  g: {base: UNIT_PRICING_BASE.WEIGHT, factor: 0.001},
  gm: {base: UNIT_PRICING_BASE.WEIGHT, factor: 0.001},
  gr: {base: UNIT_PRICING_BASE.WEIGHT, factor: 0.001},
  grm: {base: UNIT_PRICING_BASE.WEIGHT, factor: 0.001},
  l: {base: UNIT_PRICING_BASE.VOLUME, factor: 1},
  lt: {base: UNIT_PRICING_BASE.VOLUME, factor: 1},
  ltr: {base: UNIT_PRICING_BASE.VOLUME, factor: 1},
  cl: {base: UNIT_PRICING_BASE.VOLUME, factor: 0.01},
  ml: {base: UNIT_PRICING_BASE.VOLUME, factor: 0.001},
  '': {base: UNIT_PRICING_BASE.COUNT, factor: 1},
  "'s": {base: UNIT_PRICING_BASE.COUNT, factor: 1},
  '`s': {base: UNIT_PRICING_BASE.COUNT, factor: 1},
  s: {base: UNIT_PRICING_BASE.COUNT, factor: 1},
  pc: {base: UNIT_PRICING_BASE.COUNT, factor: 1},
  pcs: {base: UNIT_PRICING_BASE.COUNT, factor: 1},
  ptn: {base: UNIT_PRICING_BASE.COUNT, factor: 1},
};

export const IMAGE_UNAVAILABLE_SIZE = {
  S: 'small',
  M: 'medium',
  L: 'large',
};

export const PASSWORD_RESET_CODE = '#passwordresetcode=';
export const ACCOUNT_ACTIVATION_CODE = '#accountactivationcode=';
export const LOGIN_ERROR_HASH = '#error=';

export const PASSWORD_STATUS = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  WARNING: 'Warning',
};

// Mirrors jj-order-svc MessageDto.MessageLevel — the levels carried by the
// `messages` list on an OrderResponseDto (e.g. the card-on-file provider config).
export const MESSAGE_LEVEL = {
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
};

export const VOUCHER_STATUS = {
  NOT_APPLIED: 'NOT_APPLIED',
  APPLIED: 'APPLIED',
  ERROR: 'ERROR',
};

export const PREVIOUSLY_PURCHASED_PARAMS = {page: 0, size: 20};
export const FAVOURITES_PARAMS = {page: 0, size: 20};

// Computes how many product cards fill the visible viewport plus a buffer row.
// Falls back to 20 for SSR or very small screens.
export const getInitialPageSize = () => {
  if (typeof window === 'undefined') return 40;
  const CARD_HEIGHT = 230;
  const CARD_WIDTH = 350; // 35rem at 10px root
  const cols = Math.max(1, Math.floor(window.innerWidth / CARD_WIDTH));
  const rows = Math.ceil(window.innerHeight / CARD_HEIGHT) + 2;
  return Math.max(40, cols * rows);
};

export const CONTACT_ADMIN = {
  LOW: 'LOW',
  CRITICAL: 'CRITICAL',
};

export const POSTCODE_REGEX = /^([A-Z]{1,2}[\dA-Z]{1,2})[ ]?(\d[A-Z]{2})$/i;
export const STRING_NUM_REGEX = /[^A-Za-z0-9]/g;
export const PRODUCT_DESCRIPTION_REGEX = /\((.*)\)-/;
export const STRING_ALL_REGEX = /\s+/g;

export const PAYMENT_URL_REGEX = '/payment/(.*)/';
export const ADDRESS_REGEX = /^((?![1-9]{1,2} )[1-9]|Flat|Unit)+.*/;

export const ALLERGEN_PATTERNS = [
  {allergen: 'Barley', regex: /barley/i},
  {allergen: 'Butter/Milk', regex: /buttermilk|butter|milk(?![ ]?free)/i},
  {allergen: 'Celery', regex: /celery|celeriac/i},
  {allergen: 'Cheese', regex: /cheese/i},
  {allergen: 'Cream', regex: /\bcream[s]?\b/i},
  {allergen: 'Egg', regex: /\begg[s]?\b(?![ ]?free)/i},
  {
    allergen: 'Fish/Seafood',
    regex: /crayfish|prawn[s]?|crab[s]?|lobster[s]?|fish|crustacean[s]?/i,
  },
  {allergen: 'Gluten', regex: /gluten(?![ ]?free)/i},
  {allergen: 'Lupin', regex: /lupin/i},
  {allergen: 'Metabisulphite', regex: /metabisulphite/i},
  {allergen: 'Mollusc', regex: /mollusc[s]?/i},
  {allergen: 'Mustard', regex: /mustard/i},
  {
    allergen: 'Nuts',
    regex: /(?:brazil nut|almond|pecan nut|pistachio|macadamia nut|queensland nut|hazelnut|peanut|walnut|cashew nut)[s]?[,]?|(?: nut[s]?[,]? )/i,
  },
  {allergen: 'Oat', regex: /\bOatmeal\b|\bOat[s]?\b/i},
  {allergen: 'Pecan', regex: /pecan/i},
  {allergen: 'Rye', regex: /\brye\b/i},
  {allergen: 'Sesame', regex: /sesame/i},
  {allergen: 'Soy', regex: /soybean[s]?|soya|soy/i},
  {allergen: 'Sulphite', regex: /sulphite[s]?/i},
  {allergen: 'Sulphur Dioxide', regex: /sulphur dioxide/i},
  {allergen: 'Wheat', regex: /\bwheat([ ]?flour)?\b/i},
  {allergen: 'Yoghurt', regex: /yoghurt|yogurt/i},
];

export const ALLERGEN_HIGHLIGHT_REGEX = new RegExp(
  ALLERGEN_PATTERNS.map(({regex}) => `(?:${regex.source})`).join('|'),
  'gi'
);

export const SYSTEM_MESSAGE = {
  ANNOUNCEMENT: 'announcement-message',
  MAINTENANCE: 'maintenance-message',
};

export const FILTERS_LIMIT = 55;

export const LOCATION_FILTERS = {
  ALL: 'All',
};

export const PROMO_TAGS = {
  ONLINE_CARD: 'OnlineCard',
  Pay_By_Bank: 'PayByBank',
  FRESH_PRODUCT: 'FreshProdu',
  ADHOC: 'Adhoc',
  MULTI_BUY: 'MultiBuy',
};

export const PROMO_TAGS_MAPPING = {
  OnlineCard: 'Pay online',
  MULTI_BUY: 'MultiBuy',
};

export const PROMO_TAGS_MAP = {
  OnlineCard: 'Pay ONLINE',
};

export const CLOSED_TIME = '00:00';

export const BRANCH_NAME_MAPPING = {
  'Birmingham-Aston': 'AS-MW',
  Birmingham: 'AS-MW',
  Aston: 'AS-MW',
  Basingstoke: 'BS-MW',
  Bristol: 'BR-MW',
  'London-Dagenham': 'DG-MW',
  Dagenham: 'DG-MW',
  Doncaster: 'DN-MW',
  Leeds: 'LD-MW',
  Leicester: 'LS-MW',
  'London-Enfield': 'EN-MW',
  Enfield: 'EN-MW',
  Manchester: 'MN-MW',
  Newcastle: 'NC-MW',
  'London-Sidcup': 'SD-MW',
  Sidcup: 'SD-MW',
  England: 'EN-MW',
  england: 'EN-MW',
  Wimbeldon: 'WB-MW',
  Wimbledon: 'WB-MW',
  'London-Wimbledon': 'WB-MW',
};

export const BRANCH_MAPPING = {
  'AS-MW': 'Birmingham-Aston',
  'BS-MW': 'Basingstoke',
  'BR-MW': 'Bristol',
  'DG-MW': 'London-Dagenham',
  'DN-MW': 'Doncaster',
  'LD-MW': 'Leeds',
  'LS-MW': 'Leicester',
  'EN-MW': 'London-Enfield',
  'MN-MW': 'Manchester',
  'NC-MW': 'Newcastle',
  'SD-MW': 'London-Sidcup',
  'WB-MW': 'London-Wimbledon',
};

// Routes whose first path parameter is a branch name, e.g. /product/Doncaster/BAK506/.
export const BRANCH_NAME_URL_PREFIXES = [
  'product',
  'brand',
  'category',
  'branch',
];

// Shape of a branch code (inventLocationId), e.g. 'DN-MW'. Matched by shape rather
// than against a list of codes so a branch we have no URL name for is still
// recognised as a branch code and redirected, instead of being read as a branch name.
export const BRANCH_CODE_PATTERN = '[A-Za-z]{2}-MW';
export const BRANCH_CODE_REGEX = new RegExp(`^${BRANCH_CODE_PATTERN}$`, 'i');

// A "?" that reached us percent-encoded inside the path (/product/england/MEA463%3Fsrsltid=...),
// so the query string became part of the last path segment. See getEncodedQueryRedirectUrl.
export const ENCODED_QUERY_SEPARATOR_REGEX = /%3F/i;

// The branch-name segment used when a URL carries a branch code we have no name for.
// 'england' resolves to the default branch, which carries the widest product range.
export const DEFAULT_BRANCH_URL_NAME = 'england';

// Branch records name a branch 'Doncaster Branch'; URLs use just 'Doncaster'. The
// sitemap generator strips the same suffix, so the two agree on what a branch URL is.
export const BRANCH_NAME_SUFFIX = ' Branch';

// Segments that resolve to a branch for pricing but do not claim to be about one.
// Compared lower-case, so both 'England' and 'england' are covered.
export const COUNTRY_BRANCH_URL_NAMES = [DEFAULT_BRANCH_URL_NAME];

// Branch segments produced by a link built from an undefined/null branch variable.
// Live in Google's index from before the guard in App.js onProductClick, so they are
// still crawled and clicked; they must redirect rather than serve a fallback page.
export const INVALID_BRANCH_SEGMENTS = ['undefined', 'null'];

// The branch-name routes, restricted to the segments that cannot resolve to a branch
// name — a branch code (/product/DN-MW/BAK506/) or an undefined/null segment
// (/product/undefined/DRK548/) — and so have to be redirected.
export const BRANCH_REDIRECT_URL_PATHS = BRANCH_NAME_URL_PREFIXES.map(
  prefix =>
    `/${prefix}/:branchSegment(${[
      BRANCH_CODE_PATTERN,
      ...INVALID_BRANCH_SEGMENTS,
    ].join('|')})`
);

// Rows appended to the Storage & size tab stating stock and address for the branch
// in the URL. Google's store verification needs this rendered on the page, not only
// in the JSON-LD.
export const BRANCH_STOCK_LABELS = {
  BRANCH: 'branch',
  AVAILABILITY: 'availability',
  ADDRESS: 'branch address',
};

export const BRANCH_STOCK_STATUS = {
  IN_STOCK: 'In stock',
  OUT_OF_STOCK: 'Out of stock',
};

export const SCROLL_THRESHOLD = '70%';

export const CHECKOUT_RESULT = {
  PAYMENT_HOSTED_PAGE: 'PAYMENT_HOSTED_PAGE',
  PENDING_AUTHORIZE: 'PENDING_AUTHORIZE',
  PAYMENT_BRAINTREE: 'PAYMENT_BRAINTREE',
  PAYMENT_ECOSPEND: 'PAYMENT_ECOSPEND',
  PAYMENT_ADYEN: 'PAYMENT_ADYEN',
  PAYMENT_STRIPE: 'PAYMENT_STRIPE',
  // An earlier Pay By Bank payment for this basket is still pending at the
  // bank (jj-order-svc), so no new payment was started; `orderId` is that
  // pending order.
  PAYMENT_IN_PROGRESS: 'PAYMENT_IN_PROGRESS',
};

// The Stripe card form is a standalone page rather than a React component, so the card-on-file
// page hands over to it and is sent back with STRIPE_CARD_SAVED_PARAM set.
export const STRIPE_CARD_CAPTURE_PATH = '/stripePay/';
export const STRIPE_CARD_SAVED_PARAM = 'cardsaved';

export const MARKETING_PERMISSION_IDS = {
  EMAIL: '14e9781613',
  PRICE_GUIDE: '3b92f67c01',
  SPECIAL_OFFERS: '42269cad7c',
  SMS: 'a3d79ce778',
};

export const KEY_CODES = {
  UP: 38,
  DOWN: 40,
};

export const LEAD_TIME = 120 * 1000;
export const WEBP_FORMAT = '?format=pjpg&auto=webp';

export const SEARCH_META_KEYWORDS = [
  'jj',
  'jjfood',
  'jjfoodservice',
  'groceries',
  'food',
  'ordering',
  'Online groceries',
  'Next day food and drink',
  'Next day grocery delivery',
  'Next day food and drink delivery',
  'Bulk food delivery',
  'Food online',
  'Buy bulk food',
  'Bulk groceries',
  'Home food delivery',
  'Online ordering food',
  'online food shopping',
];

export const NO_CONTACT_OPTION = 'I am self-isolating';

export const BASKET_ITEM_TYPE = {
  ITEM: 'ITEM',
  SERVICE_CHARGE_DISCOUNT: 'SERVICE_CHARGE_DISCOUNT',
  SERVICE_CHARGE: 'SERVICE_CHARGE',
};

export const CONTACT_FREE = {
  DELIVERY: 'Contactless delivery: ',
  TEL: ' - Tel.: ',
};
export const TIME_ZONE = 'Europe/London';

export const MARKETING_OPTIONS_STATUS = {
  PENDING: 'pending',
  UNSUBSCRIBED: 'unsubscribed',
  SUBSCRIBED: 'subscribed',
};

export const WS = {
  ORDER_UPDATED: 'order-updated',
  BASKET_SYNC_UPDATED: 'basket-sync-updated',
  ANNOUNCEMENT_MESSAGE: 'announcement-message',
  MAINTENANCE_MESSAGE: 'maintenance-message',
  ERROR: 'error',
  CONNECT_ERROR: 'connect_error',
  CONNECT_FAILED: 'connect_failed',
  CONNECT_TIMEOUT: 'connect_timeout',
  RECONNECT_ATTEMPT: 'reconnect_attempt',
  BASKET_DELETED: 'basket-deleted',
  FORCE_RELOAD: 'force-reload',
  PROFILE_RELOAD: 'profile-settings-updated',
  ROUTE_TRACKER: 'route-tracker-location',
};

export const MAX_DRIVER_INSTRUCTION_LENGTH = 400;
export const MAX_DEFAULT_SLOT_REF_LENGTH = 12;
export const MAX_REFERENCE_LENGTH = 100;
export const LONG_PRODUCT_NAME_LENGTH = 69;

export const LONG_CATEGORY_LIST_FILTER_LENGTH = 90;

export const CLOUDINARY_PARAM = {
  SCALE: ',c_scale/',
  SCALE_WEBP: ',c_scale,f_webp/',
  OVERLAY_TEXT: 'l_text:',
};

export const ORDER_SOURCE = {
  AX: 'AX',
  WEB: 'WEB',
};

export const JJ_COOKIE_CONSENT = 'JJCookieConsent';

export const JJ_COOKIE_CONSENT_EXCLUDED_URLS = [
  SUCCESS_PATH,
  PAYMENT_CALLBACK_PATH,
  BRAINTREE_PATH,
];

export const CHARGE_TYPES = {
  SDD: 'SDD',
  NDD: 'NDD',
};

export const PAYMENT_FAILED_BY_CODE = {
  101: 'Payment has been declined by your bank',
  110: 'Payment has been blocked due to failed 3D secure checks',
};

export const MANUALLY_ERRORS = {
  BASKET_ONLY_OOS_ITEMS_ERROR: 'BASKET_ONLY_OOS_ITEMS_ERROR',
  BASKET_NO_ITEMS_ERROR: 'BASKET_NO_ITEMS_ERROR',
  BASKET_MIN_DELIVERY_ORDER_ERROR: 'BASKET_MIN_DELIVERY_ORDER_ERROR',
  SET_ANNOUNCEMENT_MESSAGES_FAILED: 'SET_ANNOUNCEMENT_MESSAGES_FAILED',
  SET_ANNOUNCEMENT_MESSAGES_SUCCESS: 'SET_ANNOUNCEMENT_MESSAGES_SUCCESS',
  SET_MAINTENANCE_MESSAGES_FAILED: 'SET_MAINTENANCE_MESSAGES_FAILED',
  SET_MAINTENANCE_MESSAGES_SUCCESS: 'SET_MAINTENANCE_MESSAGES_SUCCESS',
  CHECKOUT_SLOT_EXPIRED: 'CHECKOUT_SLOT_EXPIRED',
  SESSION_STORAGE_UNSUPPORTED: 'SESSION_STORAGE_UNSUPPORTED',
  AUTHORIZE_BRAINTREE_PAYMENT_FAILED: 'AUTHORIZE_BRAINTREE_PAYMENT_FAILED',
};

export const RESERVED_WORD = {
  PRIVATE: 'Private',
};

export const PAYMENT_AUTH_RESULT = {
  AUTHORIZED: 'AUTHORIZED',
  AUTHORIZE_FAILED: 'AUTHORIZE_FAILED',
  REQUEST_ERROR: 'REQUEST_ERROR',
  VERIFIED: 'VERIFIED',
  THREED_SECURE_REQUIRED: 'THREED_SECURE_REQUIRED',
};

export const BRAINTREE_TYPES = {
  APPLE_PAY: 'applePay',
  GOOGLE_PAY: 'googlePay',
  APPLE_PAY_CARD: 'ApplePayCard',
  ANDROID_PAY_CARD: 'AndroidPayCard',
};

export const BUTTON_NAME = {
  UPDATE_NOW: 'UPDATE',
  PAY_NOW: 'Pay Now',
  PLACE_ORDER: 'Place Order',
};

export const ORDER_TRACKING = {
  DELIVERED: 'Delivered',
  CANCELLED: 'Cancelled',
  DELAYED: 'Delayed',
  DELIVERING: 'Out for delivery',
  ON_THE_WAY: 'On the way',
};

export const SPLITTER = {
  LOGIN_REDIRECT: '---',
};

export const AZURE_ACCOUNT_TYPES = {
  AD: 'AD',
  B2C: 'B2C',
};

export const JJ_APOLLO = {
  URI: 'jjfoodservice://',
  ROUTES: {
    LOGIN: '/Login',
    RESET_PASSWORD: '/ResetPassword',
    order: '/AllOrdersNavigator/Order',
    SEARCH: '/Browse',
    BOOKSLOT: '/BookSlot',
    GETPIN: '/GetPin',
    PRODUCTDETAIL: '/productDetail',
  },
};

export const RESERVED_WORDS = {
  NOT_AVAILABLE: 'not available',
};

export const WEB_MODE = {
  CLEAN: 'clean',
};

export const MAX_AVAILABLE_QUANTITY = 300;

export const POSTCODE_LOOKUP_SUCCESS_CODE = 2000;

export const BRANCH_LOCATION_ID = {
  'AS-MW': 'ChIJBfBdHGC7cEgRE3Dapw8at9c',
  'BS-MW': 'ChIJO0rZ3ZMhdEgRWy5_uw3Un_A',
  'BR-MW': 'ChIJp0fTub6acUgRolbAZ_bzh_A',
  'DG-MW': 'ChIJAS9X-Xal2EcRrr1YZaUZKwk',
  'DN-MW': 'ChIJDcZdS-wPeUgR3SU0mFMYSPs',
  'LD-MW': 'ChIJgwEMFNRdeUgRxA7mbWLoKgY',
  'LS-MW': 'ChIJzcfs6xded0gRjgxbLzVaK6k',
  'EN-MW': 'ChIJjzVYCfMfdkgRbBa__a1W7mQ',
  'MN-MW': 'ChIJrbaN0bave0gRgkE2JhQ718c',
  'NC-MW': 'ChIJCQFsc0N3fkgRzi8yRtoiBxg',
  'SD-MW': 'ChIJhzYCQzus2EcRwGbkxZjc8vU',
};

export const GOOGLE_RATING_URL =
  'http://search.google.com/local/writereview?placeid=';
export const TRUST_PILOT_URL =
  'https://uk.trustpilot.com/evaluate/w.jjfoodservice.com';
export const FEEDBACK_URL =
  'https://form.jotformeu.com/oliturner/jjs-foodservice-survey?orderid=';

export const CANONICAL_ROUTE_MAP = {
  '/aboutus': 'about-us',
  '/aboutUs': 'about-us',
  '/about-us': 'about-us',
  '/halal': 'halal',
  '/JJ-PGP': 'jj-pgp',
  '/jj-pgp': 'jj-pgp',
  '/packaging': 'packaging',
  '/food-packaging': 'packaging',
  '/takeaway-packaging': 'packaging',
  '/own-brands': 'own-brands',
  '/takeaway-packaging-wholesales': 'packaging',
  '/branch/birmingham-aston': 'branch/aston',
  '/branch/london-dagenham': 'branch/dagenham',
  '/branch/london-enfield': 'branch/enfield',
  '/branch/london-sidcup': 'branch/sidcup',
};

export const MESSAGES = {
  GET_PRODUCT_DETAILS_FAILED: 'Failed to get product details, please try again',
  // Shared by CreateSignupPage's upload step and the standalone price-compare
  // upload page — both require picking delivery/collection before the invoice
  // can be compared, and should read identically wherever it's shown.
  FULFILLMENT_TYPE_REQUIRED:
    'Please select whether this was a delivery or a collection order.',
  COMMERCIAL_CARD_FAILED:
    'We’re sorry but you cannot use a business card for this payment method.',
  CONSUMER_CARD_FAILED:
    'We’re sorry but you cannot use a consumer card for this payment method.',
  ADYEN_PAYMENT_FAILED: 'Payment failed, please try again or use another card',
  // Shared by the P&G PRO and Halal landing pages' FAQ sections — both carry the
  // same delivery-day disclaimer, so it should read identically wherever it's shown.
  DELIVERY_ASSIGNED_NOTICE:
    '*Deliveries are assigned to your next available delivery day for your area',
};

export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  ARROW_DOWN: 'ArrowDown',
  ARROW_UP: 'ArrowUp',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ESCAPE: 'Escape',
};

export const GQL_ERROR_MESSAGE = {
  UNAUTHORIZED: '401: Unauthorized',
  SERVER: '500: Internal Server Error',
};

export const URL = {
  JJS_PROD: 'www.jjfoodservice.com',
  GRAPHQL_PATH: '/api/graphql',
  AZURE_AUTH_DEV:
    'https://signin-dev.jjfoodservice.com/526e914a-b7c1-428e-9606-99dab4f1389c/B2C_1A_D365_UAT_signup_signin/oauth2/v2.0',
  AZURE_AUTH_PROD:
    'https://signin.jjfoodservice.com/725c69f1-034d-41ce-a2ff-d1976381e3fe/B2C_1A_D365_PROD_signup_signinv2/oauth2/v2.0',
  AZURE_AD:
    'https://login.microsoftonline.com/c46924d0-d32d-4006-829b-d1d39bd0f672/oauth2/v2.0',
  JJS_REG_PROD: 'signup.jjfoodservice.com',
  JJS_REG_DEV: 'signup-dev.jjfoodservice.com',
};

export const ID = {
  AZURE_AD_CLIENT: '2bfe81fe-2afd-4c81-a6fc-31c808cea85c',
  AZURE_CLIENT_DEV: 'beee65ca-8eed-4dd7-b621-b1ddd61e114a',
  AZURE_CLIENT_PROD: 'a622e243-89ba-4c69-b679-3061d990aa59',
};

export const CAMERA_STATE = {
  LIVE: 'live',
  VIDEO: 'video',
};

export const MISSING_ITEM = 'Missing Item';
export const QUALITY_ISSUE = 'Quality issue';

export const REFUND_REASONS = [
  QUALITY_ISSUE,
  'Damaged product',
  'Wrong item',
  'Pricing issuing',
  'Short dated / expired',
  MISSING_ITEM,
];

export const SIZE_LIMIT = {
  REQUEST_REFUND_IMAGE: 8999,
};

export const DESCRIPTIONS = {
  'advance order':
    'JJ Advance Order is a new service which allows you to access a wider range of fresh meats, poultry, fruits, and vegetables. Save time with our restaurant grade, pre-cut and pre-marinated meat and poultry. Our products are sourced to order, directly from farms and producers, to provide maximum freshness.',
};

export const ECOSPEND_STATUS = {
  VERIFIED: 'Verified',
  COMPLETED: 'Completed',
  CANCELED: 'Canceled',
  FAILED: 'Failed',
  REJECTED: 'Rejected',
  ABANDONED: 'Abandoned',
};

export const ECOSPEND_ERROR = {
  USER_CANCELED: 'user_canceled',
  INVALID_BANK_ID: 'invalid bank id',
};

export const PRODUCT_ORIGIN = {
  UK: 'United Kingdom',
  GB: 'Great Britain',
};

export const THE_DATE = {
  REFUND_DEV: 180,
  REFUND_PROD: 28,
};

export const COMMERCIAL_CARD = 'COMMERCIAL_CARD';

export const WIX_ERROR = {
  INVALID_ID: 'invalid id',
};

export const ADYEN_ERROR = {
  REFUSED: 'REFUSED',
  THREE_DS_FAILED: 'THREE_DS_FAILED',
  CONSUMER_CARD: 'CONSUMER_CARD',
  COMMERCIAL_CARD: 'COMMERCIAL_CARD',
};

export const ADYEN_ENV = {
  DEV: 'test',
  PROD: 'prod',
};

export const ADYEN_ANALYTICS_STATUS = {
  THREEDS_REQUIRED: '3ds required',
  STORED_PAYMENT_ERROR: 'storedPaymentMethod error',
  AUTH_PAYMENT_FAILED: 'payment auth failed',
  PAYMENT_AUTHED: 'payment authorized',
  PAYMENT_ERROR: 'process payment error',
  THREEDS_FAILED: '3ds failed',
  OTHER_PAYMENT_FAILED: 'payment failed',
  DONATIONS: 'donations',
  DONATION_SUCCESS: 'donations success',
  DONATION_FAILED: 'donations failed',
};

export const MAP_CENTER_LAT_LNG = {
  lat: 51.678417,
  lng: -0.020906,
};

export const STRAPI_CMS_URL = {
  DEV: 'https://cms-dev.jjfoodservice.com',
  UAT: 'https://jj-cms-mercury-uat.ecom.notprod.jjfoodservice.com',
  PROD: 'https://cms2.jjfoodservice.com',
};

export const OFFER_TYPES = {
  MIX: 'Mix & Save',
};

export const QUERY_PROMO_TAG_ID = 'offer.promoTagId';

export const ADYEN_DONATION_CAMPAIGN = 'DOCA4295Z22322595LPBJ9H28J4SWM';
export const ADYEN_CUSTOM_RESPONSE = {
  resultCode: 'Authorised',
};

export const REGISTER_SECTOR_AND_SUBCATEGORIES = {
  'Restaurants & Casual Dining': [
    {name: 'Japanese Restaurant', id: 'SHU'},
    {name: 'Korean Restaurant', id: 'KOR'},
    {name: 'Mexican Restaurant', id: 'MEX'},
    {name: 'Thai Restaurant', id: 'THA'},
    {name: 'Lebanese Restaurant', id: 'LBR'},
    {name: 'Greek Restaurant', id: 'GRK'},
    {name: 'Italian Restaurants', id: 'ITR'},
    {name: 'Turkish Restaurant', id: 'TRK'},
    {name: 'Indian Restaurant', id: 'IND'},
    {name: 'Chinese Restaurant', id: 'CHR'},
    {name: 'General Restaurant', id: 'RES'},
  ],
  'Schools & Higher Education': [
    {name: 'Education - Independent', id: 'ISI'},
    {name: 'University', id: 'UNI'},
  ],
  'Sandwich Bars & Cafes': [
    {name: 'Café', id: 'CAF'},
    {name: 'Sandwich Bar & Deli', id: 'SAN'},
    {name: 'Office Canteen', id: 'OFC'},
    {name: 'Bakery', id: 'BAK'},
  ],
  'Events & Mobile Catering': [
    {name: 'Mobile Van', id: 'VAN'},
    {name: 'Event Catering', id: 'EVC'},
    {name: 'Outside Catering', id: 'OUT'},
  ],
  'Travel & Leisure': [
    {name: 'Leisure Centre', id: 'LEC'},
    {name: 'Theme Park', id: 'TMP'},
    {name: 'Health Club', id: 'HLC'},
    {name: 'Garden Centres', id: 'GDC'},
  ],
  Hotels: 'HOT',
  'Pubs & Bars': 'PUB',
  Exports: 'OVE',
  'Home Consumers': 'CNM',
  Wholesalers: 'WHO',
  'Care & Hospitals': [
    {name: 'Care/Nursing Homes', id: 'CHO'},
    {name: 'National Health Service', id: 'NHS'},
  ],
  'Independent Retailers': [
    {name: 'Supermarket', id: 'SUP'},
    {name: 'Butcher', id: 'BUT'},
  ],
  'Takeaway & Fast-Food': [
    {name: 'Fish & Chips Restaurant', id: 'FIS'},
    {name: 'Chicken Restaurant', id: 'CHI'},
    {name: 'Pizza Restaurant', id: 'PIZ'},
    {name: 'Burger Restaurant', id: 'BUR'},
    {name: 'Kebab Restaurant', id: 'KEB'},
    {name: 'Takeaway', id: 'TAK'},
  ],
};

export const COMPLETE_PROFILE_ERRORS = {
  email: 'Email is required',
  readOnlyEmail: 'Email is required',
  postalCode: 'Please enter a postcode',
  streetAddress: 'Please enter an address',
  city: 'Please enter a city',
  displayName: 'Name is required',
  businessName: 'Please enter a business name',
  businessCustomerType: 'Please select customer type',
  ageConfirmation: "Please confirm you're over 18",
  termsAndConditionsAndPrivacyPolicyAccept:
    'Please accept the Terms and Conditions',
  latitude: 'Latitude is required',
  longitude: 'Longitude is required',
  whereDidYouHearAboutUs: 'Please select where did you hear about us',
};

export const LOADING_STATUS = {
  USE_SAVED_CARD: 'use_saved_card',
};

export const KIOSK_HOMEPAGE_IMAGE_IDS = {
  NEW_PRODUCTS: 'newProducts',
};

export const BUBBLE_MESSAGES = {
  BEST_DEAL: `You've got the best deal!`,
};

// Mirror of ExistingAccountMatchService.STRONG_MATCH_THRESHOLD — at/above this a match blocks creation.
export const STRONG_MATCH_THRESHOLD = 70;

// Only these are shown to the customer for confirmation. Email/mobile are already captured in the
// Contact Information section above, and the verification-only fields (registered Business Name, VAT
// Number, Company Number, Website) plus the source tags stay server-side for the team to check.
export const CUSTOMER_FIELDS = [
  'tradingName',
  'streetAddress',
  'city',
  'postalCode',
  'contactName',
  'customerType',
];

// Customer type codes recognised by onboarding/D365 — mirror of
// account-signup-ui/src/constants/customerTypes.ts. The signup form must send one of
// these codes, not free text, or D365 rejects the registration.
export const SIGNUP_CUSTOMER_TYPES = [
  // Restaurants & Casual Dining
  {
    id: 'SHU',
    name: 'Japanese Restaurant',
    group: 'Restaurants & Casual Dining',
  },
  {id: 'KOR', name: 'Korean Restaurant', group: 'Restaurants & Casual Dining'},
  {id: 'MEX', name: 'Mexican Restaurant', group: 'Restaurants & Casual Dining'},
  {id: 'THA', name: 'Thai Restaurant', group: 'Restaurants & Casual Dining'},
  {
    id: 'LBR',
    name: 'Lebanese Restaurant',
    group: 'Restaurants & Casual Dining',
  },
  {id: 'GRK', name: 'Greek Restaurant', group: 'Restaurants & Casual Dining'},
  {
    id: 'ITR',
    name: 'Italian Restaurants',
    group: 'Restaurants & Casual Dining',
  },
  {id: 'TRK', name: 'Turkish Restaurant', group: 'Restaurants & Casual Dining'},
  {id: 'IND', name: 'Indian Restaurant', group: 'Restaurants & Casual Dining'},
  {id: 'CHR', name: 'Chinese Restaurant', group: 'Restaurants & Casual Dining'},
  {id: 'RES', name: 'General Restaurant', group: 'Restaurants & Casual Dining'},
  // Takeaway & Fast-Food
  {id: 'FIS', name: 'Fish & Chips Restaurant', group: 'Takeaway & Fast-Food'},
  {id: 'CHI', name: 'Chicken Restaurant', group: 'Takeaway & Fast-Food'},
  {id: 'PIZ', name: 'Pizza Restaurant', group: 'Takeaway & Fast-Food'},
  {id: 'BUR', name: 'Burger Restaurant', group: 'Takeaway & Fast-Food'},
  {id: 'KEB', name: 'Kebab Restaurant', group: 'Takeaway & Fast-Food'},
  {id: 'TAK', name: 'Takeaway', group: 'Takeaway & Fast-Food'},
  // Sandwich Bars & Cafes
  {id: 'CAF', name: 'Café', group: 'Sandwich Bars & Cafes'},
  {id: 'SAN', name: 'Sandwich Bar & Deli', group: 'Sandwich Bars & Cafes'},
  {id: 'OFC', name: 'Office Canteen', group: 'Sandwich Bars & Cafes'},
  {id: 'BAK', name: 'Bakery', group: 'Sandwich Bars & Cafes'},
  // Pubs & Bars
  {id: 'PUB', name: 'Pubs & Bars', group: 'Pubs & Bars'},
  // Hotels
  {id: 'HOT', name: 'Hotels', group: 'Hotels'},
  // Events & Mobile Catering
  {id: 'VAN', name: 'Mobile Van', group: 'Events & Mobile Catering'},
  {id: 'EVC', name: 'Event Catering', group: 'Events & Mobile Catering'},
  {id: 'OUT', name: 'Outside Catering', group: 'Events & Mobile Catering'},
  // Travel & Leisure
  {id: 'LEC', name: 'Leisure Centre', group: 'Travel & Leisure'},
  {id: 'TMP', name: 'Theme Park', group: 'Travel & Leisure'},
  {id: 'HLC', name: 'Health Club', group: 'Travel & Leisure'},
  {id: 'GDC', name: 'Garden Centres', group: 'Travel & Leisure'},
  // Schools & Higher Education
  {
    id: 'ISI',
    name: 'Education - Independent',
    group: 'Schools & Higher Education',
  },
  {id: 'UNI', name: 'University', group: 'Schools & Higher Education'},
  // Care & Hospitals
  {id: 'CHO', name: 'Care/Nursing Homes', group: 'Care & Hospitals'},
  {id: 'NHS', name: 'National Health Service', group: 'Care & Hospitals'},
  // Independent Retailers
  {id: 'SUP', name: 'Supermarket', group: 'Independent Retailers'},
  {id: 'BUT', name: 'Butcher', group: 'Independent Retailers'},
  // Other
  {id: 'CNM', name: 'Home Consumers', group: 'Home Consumers'},
  {id: 'WHO', name: 'Wholesalers', group: 'Wholesalers'},
  {id: 'OVE', name: 'Exports', group: 'Exports'},
];

export const SIGNUP_CUSTOMER_TYPE_NAME_BY_ID = SIGNUP_CUSTOMER_TYPES.reduce(
  (acc, ct) => {
    acc[ct.id] = ct.name;
    return acc;
  },
  {}
);

// Signup document photos are read by OCR/AI extraction, so capture them as large and
// crisp as the device allows. Without explicit constraints getUserMedia commonly
// defaults to 640×480, which is unreadable for invoices.
export const SIGNUP_PHOTO_CAPTURE_CONSTRAINTS = {
  width: {ideal: 4096},
  height: {ideal: 2160},
};
export const SIGNUP_PHOTO_MAX_DIMENSION = 2560;
export const SIGNUP_PHOTO_JPEG_QUALITY = 0.92;

export const PRICE_COMPARE_LABEL = 'JJ Price Compare AI. Save more';

export const CONFIRMATION_PRICE_COMPARE_BANNER = {
  DESKTOP_IMAGE:
    'https://cdn.jjfoodservice.com/cms/AI_Price_Comparison_a5587898ee.jpg',
  MOBILE_IMAGE:
    'https://cdn.jjfoodservice.com/cms/AI_Price_Comparison_a5587898ee.jpg',
  LINK:
    '/content/price-compare-ai?utm_source=website&utm_medium=confirmation-banner&utm_campaign=price-compare-ai',
};

export const PRICE_COMPARE_HELP_VIDEO = {
  EMBED_URL: 'https://www.youtube.com/embed/oO7Zvumfs8g',
};

// Strapi settings arrive as strings, so feature flags are compared against this
// rather than coerced to a boolean.
export const SETTING_ENABLED = 'true';

// Friendly labels for ExistingAccountMatch.matchedOn values returned by account-signup-svc.
export const SIGNUP_MATCHED_ON_LABELS = {
  name: 'business name',
  postcode: 'postcode',
  streetNumber: 'street number',
  phone: 'phone number',
  email: 'email address',
};

export const SIGNUP_CUSTOMER_TYPE_GROUPS = SIGNUP_CUSTOMER_TYPES.reduce(
  (groups, ct) => {
    const existing = groups.find(g => g.group === ct.group);
    if (existing) {
      existing.types.push(ct);
    } else {
      groups.push({group: ct.group, types: [ct]});
    }
    return groups;
  },
  []
);

export const SIGNUP_STAFF_STEP_LABELS = [
  'Contact Infomation',
  'Upload Photo',
  'Confirm Details',
  'Price Comparison',
];

// Non-staff can't review/confirm anything themselves (only staff/admin may
// submit — see refer-a-business-openapi.yaml), so they skip straight from
// Upload Photo to Price Comparison — no separate confirm/review step.
export const SIGNUP_NON_STAFF_STEP_LABELS = [
  'Contact Infomation',
  'Upload Photo',
  'Price Comparison',
];

export const SIGNUP_TERMINAL_STATUSES = [
  'VERIFIED',
  'FAILED',
  'ACCOUNT_CREATED',
];
// Non-staff signups poll only to learn whether the business may already have
// an account, which the backend decides at VERIFIED. Stop there, or at any
// later or failed state; and give up quietly after ~5 minutes.
export const REFERRER_POLL_DONE_STATUSES = [
  'VERIFIED',
  'SUBMITTING',
  'SUBMITTED',
  'ACCOUNT_CREATED',
  'REJECTED',
  'FAILED',
];
export const REFERRER_POLL_INTERVAL_MS = 3000;
export const REFERRER_POLL_MAX_ATTEMPTS = 100;
// Create Signup: polling the signup for the invoice-scanning id of its documents.
// The send happens within a second or two of the upload; give up after a minute.
export const REFERRAL_SCAN_POLL_INTERVAL_MS = 2000;
export const REFERRAL_SCAN_POLL_MAX_ATTEMPTS = 30;
export const PUBLIC_INVOICE_REG_STEP_LABELS = [
  'Contact information',
  'Confirmation',
];

// Post-delivery "How were your products?" popup. Reviews go through the same
// submitReview mutation as the product page's "Leave a review".
export const ORDER_FEEDBACK = {
  TOTAL_STARS: 5,
  COMMENT_MAX_LENGTH: 1000,
  IMAGE_SIZE: 'w_120,h_120',
};

// SVG paths (24x24 viewBox) of the feedback modal's icons
// (components/FeedbackModal/FeedbackModal.icons.js).
export const FEEDBACK_ICON_PATHS = {
  STAR:
    'M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.3l-5.9 3.3 1.3-6.6-4.9-4.6 6.6-.8z',
  CLOSE: 'M5 5l14 14M19 5L5 19',
  COMMENT:
    'M12 4c4.4 0 8 3 8 6.8s-3.6 6.8-8 6.8c-1 0-2-.1-2.9-.4L5 19l1-3.6C4.8 14.2 4 12.6 4 10.8 4 7 7.6 4 12 4z',
  TICK: 'M5 12.5l4.5 4.5L19 7.5',
};

// The product-review service's refusals, in errors[0].extensions.code. Both
// lock the item: ALREADY_REVIEWED for this order, RECENTLY_REVIEWED within the
// last 6 weeks whatever the order (its message says when it can be reviewed
// again and is shown as is).
export const REVIEW_ERROR_CODE = {
  ALREADY_REVIEWED: 'ALREADY_REVIEWED',
  RECENTLY_REVIEWED: 'RECENTLY_REVIEWED',
};

// Fixed `reason` codes for a failed review submit (analytics), never the
// server's message, which names the account.
export const REVIEW_FAILURE_REASON = {
  ALREADY_REVIEWED: 'already_reviewed',
  RECENTLY_REVIEWED: 'recently_reviewed',
  ERROR: 'error',
};

// Outcome of a submit in the shared feedback modal (order popup and the
// product page's "Leave a review").
export const FEEDBACK_RESULT = {
  SUCCESS: 'success',
  PARTIAL: 'partial',
  FAILED: 'failed',
};

// The product page's "Leave a review", shown in the same modal as the order
// feedback popup for that one product.
export const PRODUCT_REVIEW_COPY = {
  TITLE: 'Leave a review',
  SUBTITLE:
    'Tell us what you think of this product. Your feedback helps us keep the quality you expect.',
  CANCEL: 'Cancel',
};

export const ORDER_FEEDBACK_COPY = {
  TITLE: 'How were your products?',
  SUBTITLE:
    'Rate the products in your last order. Your feedback helps us keep the quality you expect.',
  COMMENT_PLACEHOLDER: 'Tell us more (optional)',
  ADD_COMMENT: 'Add comment',
  HIDE_COMMENT: 'Hide comment',
  RATED_COUNT: (rated, total) => `${rated} of ${total} rated`,
  SUBMIT: 'Submit feedback',
  SUBMITTING: 'Submitting…',
  MAYBE_LATER: 'Maybe later',
  CLOSE: 'Close',
  STAR_LABEL: (star, itemName) =>
    `${star} star${star > 1 ? 's' : ''} for ${itemName}`,
  SUCCESS_TITLE: 'Thank you for your feedback',
  SUCCESS_TEXT:
    'Your ratings have been sent. They help us keep the quality you expect.',
  PARTIAL_FAILURE_TITLE: 'Some ratings weren’t sent',
  PARTIAL_FAILURE_TEXT:
    'The others have been saved. The reason is shown under each product below. Please try again, or contact customer services if this keeps happening.',
  FAILURE_TEXT:
    'Your ratings weren’t sent. You’ll find the reason under each product below. Your ratings are still here, so please submit again. If this keeps happening, contact customer services.',
  // Under a product whose rating failed with no message from the server
  // (e.g. a network failure).
  ITEM_FAILED: 'We couldn’t send this rating because of an issue on our end.',
  DONE: 'Done',
};
